import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export function Card({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200 ${className}`} {...props} data-id="element-108">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`p-6 pb-3 ${className}`} {...props} data-id="element-109">
      {children}
    </div>;
}
export function CardContent({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`p-6 pt-0 ${className}`} {...props} data-id="element-110">
      {children}
    </div>;
}
export function CardFooter({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`p-6 pt-0 flex items-center ${className}`} {...props} data-id="element-111">
      {children}
    </div>;
}